import { SagaIterator } from 'redux-saga';
import { cancel, put, select, takeLatest } from 'redux-saga/effects';
import { App, Produktlinie } from '@ps20-frontend/frontend-models';
import { Produktlinienname } from '@ps20/bff-models';
import cloneDeep from 'lodash/cloneDeep';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { AnyAction } from 'redux';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { RsActions } from '../rsActions';
import { selectRechtsstreitigkeitenUeberschritten } from '../../app/shared/selectors/rechtsstreitRechtsberatung.selector';
import { selectProduktlinien } from '../../app/shared/selectors/produkt.selector';
import { IAppState } from '../appState';

export function* watchproduktlinienSaga(): SagaIterator {
  yield takeLatest(
    RsActions.RECHTSSTREITIGKEITEN_CHANGED,
    safeSaga(updateProduktlinienStatus, App.RS),
  );
  yield takeLatest(
    RsActions.ANZAHL_RECHTSSTREITIGKEITEN_CHANGED,
    safeSaga(updateProduktlinienStatus, App.RS),
  );
  yield takeLatest(GlobalActions.PRODUKT_RECEIVED, safeSaga(updateProduktlinienStatus, App.RS));
}

export function* updateProduktlinienStatus(action: AnyAction): SagaIterator {
  const state: IAppState = yield select();
  if (
    (action.type === GlobalActions.PRODUKT_RECEIVED && action.payload.appId !== App.RS) ||
    state.vertragsoptionen?.beibehalten
  ) {
    yield cancel();
  } else {
    const vorschaedenUeberschritten: boolean = yield select(
      selectRechtsstreitigkeitenUeberschritten,
    );
    const produktlinienCopy: Array<Produktlinie> = cloneDeep(yield select(selectProduktlinien));

    activateEveryProduktlinie(produktlinienCopy);

    if (vorschaedenUeberschritten) {
      deactivateGivenProduktlinien(
        produktlinienCopy,
        Produktlinienname.BASIS,
        Produktlinienname.SMART,
      );
      updateSelectedProduktlinie(produktlinienCopy);
    }

    const changeProduktlinienAction = new RsActions().produktlinienChanged(produktlinienCopy);
    yield put(changeProduktlinienAction);
  }
}

function activateEveryProduktlinie(produktlinien: Produktlinie[]) {
  produktlinien.forEach(produktlinie => (produktlinie.deactivated = false));
}

function deactivateGivenProduktlinien(
  produktlinien: Produktlinie[],
  ...produktlinienToDeactivate: Produktlinienname[]
) {
  produktlinien.forEach(tarifItem => {
    if (produktlinienToDeactivate.includes(tarifItem.produktName)) {
      tarifItem.deactivated = true;
    }
  });
}

export function updateSelectedProduktlinie(produktlinien: Produktlinie[]) {
  const invalidSelectedProduktline = produktlinien.find(
    produktlinie => produktlinie.deactivated && produktlinie.selected,
  );
  const validSelectedProduktline = produktlinien.find(
    produktlinie => !produktlinie.deactivated && produktlinie.selected,
  );

  if (invalidSelectedProduktline != null) {
    invalidSelectedProduktline.selected = false;
  }
  if (validSelectedProduktline == null) {
    selectValidProduktlinie(produktlinien);
  }
}

function selectValidProduktlinie(produktlinien: Produktlinie[]) {
  const activatedProduktlinien = produktlinien.filter(produktlinie => !produktlinie.deactivated);
  const produktlinieToActivate = activatedProduktlinien.find(
    produktlinie => produktlinie.produktName === Produktlinienname.KOMFORT,
  );

  if (produktlinieToActivate != null) {
    produktlinieToActivate.selected = true;
  } else if (activatedProduktlinien.length > 0) {
    activatedProduktlinien[0].selected = true;
  }
}
